"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClearFilters = void 0;
const react_instantsearch_1 = require("react-instantsearch");
const constants_1 = require("../../constants");
const useClearFilters = (filters, hierarchyFilters) => {
    const allfiltersValue = filters
        .map(attr => attr.key)
        .filter(key => !constants_1.EXCEPTIONAL_REFINEMENT_KEYS.has(key))
        .concat((hierarchyFilters === null || hierarchyFilters === void 0 ? void 0 : hierarchyFilters.map(attr => attr.key)) || []);
    const { refine: clearAllRefinements } = (0, react_instantsearch_1.useClearRefinements)({
        includedAttributes: allfiltersValue,
    });
    return clearAllRefinements;
};
exports.useClearFilters = useClearFilters;
